// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sidebar on the left - 5:4 split (sidebar takes ~55.6%, map takes ~44.4%) */
.sidebar {
  background-color: aqua;
  height: 100%;
  width: 100%;
  min-width: 450px;
  background: white;
  border-right: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  order: 1;
}

/* Ensure sidebar content fills full width */
.sidebar__content-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.sidebar-navigation {
  height: 150px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
}

/* Make all sidebar components fill full width */
.sidebar__content-wrapper .sidebar-tabs,
.sidebar__content-wrapper .tab-content,
.sidebar__content-wrapper .search-container,
.sidebar__content-wrapper .search-bar-with-filter {
  width: 100%;
  box-sizing: border-box;
}

/* Override any max-width constraints on sidebar content */
.sidebar .search-container,
.sidebar .sidebar-tabs,
.sidebar .tab-content {
  max-width: none;
  width: 100%;
}

/* SIDEBAR CONTENT */

.sidebar-content {
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/Sidebar/sidebar.css"],"names":[],"mappings":"AAAA,6EAA6E;AAC7E;EACE,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,QAAQ;AACV;;AAEA,4CAA4C;AAC5C;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA,gDAAgD;AAChD;;;;EAIE,WAAW;EACX,sBAAsB;AACxB;;AAEA,0DAA0D;AAC1D;;;EAGE,eAAe;EACf,WAAW;AACb;;AAEA,oBAAoB;;AAEpB;EACE,YAAY;AACd","sourcesContent":["/* Sidebar on the left - 5:4 split (sidebar takes ~55.6%, map takes ~44.4%) */\n.sidebar {\n  background-color: aqua;\n  height: 100%;\n  width: 100%;\n  min-width: 450px;\n  background: white;\n  border-right: 1px solid #e2e8f0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  order: 1;\n}\n\n/* Ensure sidebar content fills full width */\n.sidebar__content-wrapper {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.sidebar-navigation {\n  height: 150px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Make all sidebar components fill full width */\n.sidebar__content-wrapper .sidebar-tabs,\n.sidebar__content-wrapper .tab-content,\n.sidebar__content-wrapper .search-container,\n.sidebar__content-wrapper .search-bar-with-filter {\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* Override any max-width constraints on sidebar content */\n.sidebar .search-container,\n.sidebar .sidebar-tabs,\n.sidebar .tab-content {\n  max-width: none;\n  width: 100%;\n}\n\n/* SIDEBAR CONTENT */\n\n.sidebar-content {\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
